import React from "react"
import Layout from "./../components/layout"

export default function Home() {
  return (
    <Layout>
      <a
        href="https://github.com/users/burubur/projects/11"
        target="blank"
        className="label"
      >
        Project Status
      </a>
    </Layout>
  )
}
